// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import { faHandshake } from '@fortawesome/free-solid-svg-icons'
import { faQuestion } from '@fortawesome/free-solid-svg-icons'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
//Vue-form-wizard
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//Vue-Goog-Table

import VueGoodTablePlugin from 'vue-good-table';

// import the styles 
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);

//element-ui
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/element-variables.scss'
import frLocale from 'element-ui/lib/locale/lang/fr'

//Vuex Store

import {store} from './store/store'
import {mapActions, mapMutations} from 'vuex'

Vue.use(VueFormWizard)
Vue.use(ElementUI,{frLocale})

library.add(faCoffee,faHome,faQuestion, faHandshake,faBriefcase,faPhone,faCheck)

Vue.component('fa', FontAwesomeIcon)

// Vue.locale('en-EN', enLocale)
// Vue.locale('fr-FR', frLocale)
// Vue.config.lang = 'fr-FR'


Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  methods:{
    ...mapActions([
      'getFields',
      'getPays',
      'activites',
      'initLoginError',
      'initCheckingUnique',
      'initCheckingMailUnique',
      'initConnecting',
      'uniqueOK',
      'uniqueMailOK',
      'typeFournisseurs',
      'settings',
      'configs'
    ]),
    ...mapMutations([
      'init_after_login_files',
      'init_after_login_otherfiles',
      'init_after_login_messages'
    ]),
    onMountInit(){
      this.init_after_login_files()
      this.init_after_login_otherfiles()
      this.init_after_login_messages()
      this.getFields()
      this.getPays()
      this.activites()
      this.initLoginError()
      this.initCheckingUnique()
      this.initCheckingMailUnique()
      this.initConnecting()
      this.uniqueOK()
      this.uniqueMailOK()
      this.typeFournisseurs()
      this.settings()
    }
  },
  created(){
    this.configs();
  },
  mounted(){
      this.onMountInit();
    }
})